var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58163 0.5C3.20263 0.5 -0.000366211 4.856 -0.000366211 8.446C-0.000366211 10.181 0.186634 11.828 1.22363 13.21L7.09163 21.118C7.10663 21.137 7.12963 21.145 7.14563 21.163C7.20419 21.2302 7.27721 21.2832 7.3592 21.3181C7.44119 21.353 7.53003 21.3689 7.61904 21.3646C7.70805 21.3603 7.79492 21.3358 7.87313 21.2931C7.95135 21.2504 8.01887 21.1905 8.07063 21.118C9.97588 18.5747 12.328 15.818 14.138 13.21C15.4996 11 15.5246 10.108 15.5246 8.446C15.5246 4.856 11.9606 0.5 7.58163 0.5ZM7.57963 14.248C4.38763 14.248 2.16963 11.64 2.16963 8.449C2.16963 5.256 4.38863 2.647 7.57963 2.647C10.7706 2.647 13.3786 5.256 13.3786 8.447C13.3786 11.64 10.7706 14.248 7.57963 14.248Z",
    fill: "url(#paint0_linear_0_33)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_33",
    x1: -5,
    y1: 21,
    x2: 17.5,
    y2: -3.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#FD225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7A40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon-6.32b0cf3ac45454fda2c05b362c7b52d5.svg";
export { ForwardRef as ReactComponent };